import React from 'react'
import '../scss/components/section.scss'
import Header from '../components/header/header.jsx'
import Footer from '../components/footer/footer-v1/index.jsx'
import dataFooter from '../assets/fake-data/data-footer.js'
import Bottom from '../components/bottom/index.jsx'

function FAQ(props) {
    return (
        <div className='wrapper-style sv2-tnc-prvcy' id='wrapper'>
            {<Header />}
            <div className='sellagen-fact'>
                <h2 className="sellagen-fact-title"><strong>Nelima FAQ</strong></h2>
                <br/>

                {/* ## PRODUCT SECTION */}

                <h3 className='fs-20 text-color-4'>Product</h3>
                <br/>

                <p><strong>Q: What is Nelima?</strong></p>
                <br/>
                <p>A: Nelima is a general AI agent that can take one prompt and run with it for thousands of steps. She keeps going without breaking, without context limits, and without needing you to intervene. She adapts to whatever you're working on: sales, research, finance, data, etc… thanks to built-in specialists that let her go deep in any domain. The result is real, everyday productivity that feels 10x bigger.</p>
                <br/><br/>

                <p><strong>Q: How is Nelima different from other agents?</strong></p>
                <br/>
                <p>A: Most agents do one-off tasks and forget everything. Nelima can keep working on her own, remember context, create and update files, connect to your apps, and run thousands of steps in sequence. Think of her less like a chatbot and more like an actual operating system for getting work done.</p>
                <br/><br/>

                <p><strong>Q: What can I use Nelima for right now?</strong></p>
                <br/>
                <p>A: People use her for document processing, research, data analysis, lead generation, market discovery, and managing private knowledge bases. But her real value is that she adapts. If you have a workflow you want handled, ask her and she'll tell you if she can take it on.</p>
                <br/><br/>

                <p><strong>Q: Does Nelima really remember things?</strong></p>
                <br/>
                <p>A: Yes. She has persistent storage where she can create, save, and update files and recall them later. She doesn't lose context when a session ends.</p>
                <br/><br/>

                <p><strong>Q: Do I need to code or build workflows?</strong></p>
                <br/>
                <p>A: Not at all. Just write a plain-English prompt and she runs the workflow for you. No coding, no Zapier-style builders, no setup.</p>
                <br/><br/>

                <p><strong>Q: Can I teach Nelima custom tasks?</strong></p>
                <br/>
                <p>A: Yes. You can create your own functions and choose to keep them private or publish them for everyone. Just hit "Integrate" to get started.</p>
                <br/><br/>

                <p><strong>Q: Is Nelima safe for business?</strong></p>
                <br/>
                <p>A: Yes. Your data is encrypted, your credentials stay private, and your files are only accessible to you. We don't share or sell your data. Ever.</p>
                <br/><br/><br/>

                {/* ## SUBSCRIPTION & BILLING SECTION */}

                <h3 className='fs-20 text-color-4'>Subscription & Billing</h3>
                <br/>

                <p><strong>Q: How much does Nelima cost?</strong></p>
                <br/>
                <p>A: You can access Nelima right now for $40/month!</p>
                <br/><br/>

                <p><strong>Q: Do you offer a free trial?</strong></p>
                <br/>
                <p>A: You can always use the free tier. It includes core features with usage limits. When you need more power, you can upgrade at any time.</p>
                <br/><br/>

                <p><strong>Q: How do I pay?</strong></p>
                <br/>
                <p>A: Payments run through Stripe, so any major credit or debit card works.</p>
                <br/><br/>

                <p><strong>Q: Can I cancel anytime?</strong></p>
                <br/>
                <p>A: Yes, you'll keep access until the end of your current billing cycle.</p>
                <br/><br/>

                <p><strong>Q: Do you offer refunds?</strong></p>
                <br/>
                <p>A: We don't offer partial refunds, but you can stop renewal anytime.</p>
                <br/><br/>

                <p><strong>Q: Do you have team or enterprise plans?</strong></p>
                <br/>
                <p>A: We're currently testing early enterprise features like custom integrations, more storage, and priority support. If you're interested, email <strong>support@sellagen.com</strong>.</p>
                <br/><br/><br/>

                {/* ## TROUBLESHOOTING & SUPPORT SECTION */}

                <h3 className='fs-20 text-color-4'>Troubleshooting & Support</h3>
                <br/>

                <p><strong>Q: Nelima didn't respond to my prompt. What should I do?</strong></p>
                <br/>
                <p>A: Try simplifying or rephrasing your request. If that doesn't fix it, check that your integrations or/and context are still connected.</p>
                <br/><br/>

                <p><strong>Q: A workflow stopped halfway. Why?</strong></p>
                <br/>
                <p>A: This usually happens because of missing permissions or missing context. Double-check your integrations and try again.</p>
                <br/><br/>

                <p><strong>Q: How do I contact support?</strong></p>
                <br/>
                <p>A: Email <strong>support@sellagen.com</strong>, <strong>james.kachamila@sellagen.com</strong> or <strong>arjon.das@sellagen.com</strong> and we'll get back to you asap.</p>
                <br/><br/>

                <p><strong>Q: How do I request a new feature?</strong></p>
                <br/>
                <p>A: You can email us or share feedback in our Discord community. We prioritize features that help the most users.</p>
                <br/><br/><br/>

            </div>
            {<Footer data={dataFooter}/>}
            {<Bottom classection='widget-social-footer'/>}
        </div>
    )
}

export default FAQ